import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "content-filter" }
const _hoisted_2 = { class: "content-filter__container" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_uefa_content_list = _resolveComponent("uefa-content-list")!
  const _component_widget_block = _resolveComponent("widget-block")!
  const _component_page_layout = _resolveComponent("page-layout")!

  return (!_ctx.fullpageMode)
    ? _withDirectives((_openBlock(), _createBlock(_component_widget_block, {
        key: 0,
        title: _ctx.title,
        "show-divider": !!_ctx.title,
        "show-slider": _ctx.showSlider && !!_ctx.scoreList.length,
        "btn-label": _ctx.btnLabel,
        "btn-url": _ctx.btnUrl
      }, {
        default: _withCtx(() => [
          _createVNode(_component_uefa_content_list, {
            contents: _ctx.scoreList,
            "show-slider": _ctx.showSlider
          }, null, 8, ["contents", "show-slider"])
        ]),
        _: 1
      }, 8, ["title", "show-divider", "show-slider", "btn-label", "btn-url"])), [
        [_vShow, _ctx.scoreList.length]
      ])
    : (_openBlock(), _createBlock(_component_page_layout, {
        key: 1,
        title: _ctx.title
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scoreListBySeries, (series) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (series.items.length)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: series.value,
                        type: "button",
                        class: _normalizeClass(["content-filter__button", { 'selected': _ctx.isFilterSelected(series.value) }]),
                        onClick: _withModifiers(($event: any) => (_ctx.toggleFilter(series.value)), ["prevent"])
                      }, _toDisplayString(series.label), 11, _hoisted_3))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scoreListBySeries, (series) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (series.items.length && (!_ctx.selectedFilter || _ctx.isFilterSelected(series.value)))
                ? (_openBlock(), _createBlock(_component_widget_block, {
                    key: 0,
                    title: series.label,
                    class: "uefa-page-content"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_uefa_content_list, {
                        contents: series.items
                      }, null, 8, ["contents"])
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ]),
        _: 1
      }, 8, ["title"]))
}